/**
 * TenantRoute - Route guard that requires tenant context
 *
 * Only allows access when user is on a tenant subdomain (e.g., my-org.eventik.cz)
 * Redirects to home page if on main domain (no tenant)
 */

import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { getTenantSlug } from '../api/client';

interface TenantRouteProps {
  children?: React.ReactNode;
}

const TenantRoute: React.FC<TenantRouteProps> = ({ children }) => {
  const location = useLocation();
  const tenantSlug = getTenantSlug();

  // If no tenant context, redirect to home
  if (!tenantSlug) {
    // Store the intended destination for after tenant selection
    return <Navigate to="/" state={{ from: location, message: 'Please access this page from your organization subdomain.' }} replace />;
  }

  // Has tenant context - allow access
  return children ? <>{children}</> : <Outlet />;
};

export default TenantRoute;
